import React from "react";

const changeLog = [
  {
    version: "1.0",
    changes: ["Created standalone demonstration"],
  },
  {
    version: "0.1",
    changes: ["Typed some keys", "Cloned CodeSandbox boilerplate"],
  },
];

export default function ChangelogPage() {
  return (
    <>
      <header className="Page-header">
        <h1>Changelog</h1>
      </header>
      <section className="Page-body">
        <p>History of application changes</p>
        <Changelog log={changeLog} />
      </section>
    </>
  );
}

function Changelog({ log }) {
  return (
    <table className="Changelog-list">
      <tbody>
        {log.map(item => (
          <ChangelogItem key={item.version} {...item} />
        ))}
      </tbody>
    </table>
  );
}

function ChangelogItem({ version, date, changes = [] }) {
  return (
    <tr className="Changelog-item" key={version}>
      <td>
        <h3>{version}</h3>
      </td>
      <td>
        <ul>
          {changes.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </td>
    </tr>
  );
}
